export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
/**
 * @param choice number
 * @param choicesLength number
 * http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html#sr
 */
export function pluralizationRules(choice, choicesLength) {
	let result = 3; //many
	if (choice === 0) {
		return 0; //Special case zero
	}

	const teen = (choice % 100) > 10 && (choice % 100) < 20;
	const digit = choice % 10;

	if (!teen && digit === 1) {
		result = 1; //one
	}

	if (!teen && digit >= 2 && digit <= 4) {
		result = 2; //few
	}

	return Math.min(result, choicesLength - 1);
};

export const messages = {
    "login.form.title": "Пријавите се",
    "login.form.hint.user": "Акредитив за пријављивање",
    "login.form.hint.password": "Лозинка",
    "login.form.checkbox.remember-me": "Запамти ме",
    "login.form.button.sign-in": "Пријавите се",
    "login.form.message.invalid-user-credentials": "Име за пријављивање или лозинка су нетачни",
    "login.form.message.account-temporarily-locked": "Ваш налог је привремено закључан, вратите се за 5 минута",
    "login.form.message.user-required": "Унесите име за пријављивање",
    "login.form.message.password-required": "Унесите лозинку",
    "login.form.button.forgot-password": "Заборавили сте лозинку?",
    "error.mfa-required.title": "Подесите 2FA",
    "error.mfa-required.message1": "За заштиту вашег налога потребна је двофакторска потврда идентитета (2FA).",
    "error.mfa-required.message2": "Бићете преусмерени на подешавања налога у Online Dashboard-у. Омогућите 2FA, пратите упутства за подешавање, а затим се вратите овде.",
    "error.mfa-required.learnMore": "Сазнајте више о 2FA",
    "error.mfa-required.continue": "Настави",
    "error.root-admin-login.title": "Грешка 403 – забрањено",
    "error.root-admin-login.message": "Пријављени сте као администратор само за читање. Да бисте приступили Web Recovery конзоли, пријавите се као корисник закупца клијента или администратор уместо тога",
    "error.server-busy.message": "Сервер је заузет, покушајте поново касније.",
    "error.network-connection.title": "Грешка са мрежном везом",
    "error.network-connection.message": "Проверите интернет везу и покушајте поново.",
    "error.internal-server-error.title": "Унутрашња грешка сервера",
    "error.internal-server-error.message": "Да бисте исправили грешку, обратите се подршци са детаљима грешке:",
    "error.internal-server-error.copy.button": "Копирај"
};
